import { HttpClient } from 'aurelia-fetch-client';
import { Aurelia, PLATFORM } from 'aurelia-framework';
import { TCustomAttribute } from 'aurelia-i18n';
import 'bootstrap';
import 'jwt-decode';
import '@duetds/date-picker';
import '@duetds/date-picker/dist/duet/themes/default.css';
import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.css';
import Backend from 'i18next-xhr-backend';
import 'isomorphic-fetch';
import * as moment from 'moment';
import * as numeral from 'numeral';

declare const IS_DEV_BUILD: boolean; // The value is supplied by Webpack during the build
declare var grecaptcha: any;
declare var recaptchaToken: any;

export function configure(aurelia: Aurelia) {
	aurelia
		.use
		.standardConfiguration()
		.plugin(PLATFORM.moduleName('bootstrap-datepicker'))
		.plugin(PLATFORM.moduleName('@duetds/date-picker'))
		.plugin(PLATFORM.moduleName('jwt-decode'))
		.plugin(PLATFORM.moduleName('au-table'))
		.plugin(PLATFORM.moduleName('aurelia-dialog'))
		.plugin(PLATFORM.moduleName('aurelia-inputmask'), { showMaskOnHover: true, autoUnmask: true })
		.plugin(PLATFORM.moduleName('aurelia-validation'))
		.plugin(PLATFORM.moduleName('aurelia-i18n'), (instance: any) => {

			// add aliases for 't' attribute
			var aliases = ['t'];
			TCustomAttribute.configureAliases(aliases);

			// register backend plugin
			instance.i18next.use(Backend);

			// allows fallback to hard coded text
			instance.i18next.options.skipTranslationOnMissingKey = true;

			// adapt options to your needs (see https://www.i18next.com/overview/configuration-options)
			return instance.setup({
				backend: {
					loadPath: '/PayrazrApiWeb/locales/{{lng}}/{{ns}}', // we use BusinessKey for namespace
				},
				interpolation: {
					format: (value: any, format: any, lng: any) => {
						if (!format) {
							return value;
						}

						if (value instanceof Date) {
							return moment(value).format(format);
						} else if (moment.isMoment(value)) {
							return moment(value).format(format);
						} else if (!isNaN(value)) {
							return numeral(value).format(format);
						}

						return value;
					}
				},
				attributes: aliases,
				ns: [0],
				defaultNS: '0',
				lng: 'en',
				fallbackLng: ['en'],
				debug: false // turn this on if trying to troubleshoot.. remember to turn it off!
			});
		});

	if (IS_DEV_BUILD) {
		aurelia.use.developmentLogging();
	}

	new HttpClient().configure(config => {
		const baseUrl = document.getElementsByTagName('base')[0].href;
		config.withBaseUrl(baseUrl);
	});

	grecaptcha.ready(function () {
		grecaptcha.execute('6LdktKEUAAAAAIu1oqO_WwHDZkk5YKsTm-QzwdgJ', { action: 'homepage' })
			.then(function (token) {
				recaptchaToken = token;
			}).catch(() => {
				console.log('Error: Unable to retrieve recaptcha token.');
			}).then(function () {
				aurelia.start().then(() => aurelia.setRoot('pages/app'));
			});
	});
}
